import { getConfigApi } from '../config'
import { getFetch, postFetch, putFetch, deleteFetch } from 'utils/fetch'

function getUrl(prefix = '') {
  return getConfigApi().organization + '/' + prefix
}

export function getOrganizations(
  { itemPerPage = 10, page = 1 },
  { name, address, addressAPI, phone, status }
) {
  var urlSearch = getUrl(`?itemPerPage=${itemPerPage}&page=${page}`)
  if (name) urlSearch += `&name=${name}`
  if (address) urlSearch += `&address=${address}`
  if (addressAPI) urlSearch += `&addressAPI=${addressAPI}`
  if (phone) urlSearch += `&phone=${encodeURIComponent(phone)}`
  if (status) urlSearch += `&status=${encodeURIComponent(status)}`
  return getFetch(urlSearch)
}

export function create(data) {
  return postFetch(getUrl(), data)
}

export function getOne(_id) {
  return getFetch(getUrl(_id))
}

export function updateOne(_id, organization = {}) {
  return putFetch(getUrl(_id), organization)
}

export function removeOne(_id) {
  return deleteFetch(getUrl(_id))
}

export function deleteOne(_id) {
  return putFetch(getUrl(`delete/${_id}`))
}

export function restoreOne(_id) {
  return putFetch(getUrl(`restore/${_id}`))
}

export function updateMenu(_id, menu = {}) {
  return putFetch(getUrl(`menu/${_id}`), menu)
}

export default {
  getOrganizations,
  create,
  getOne,
  updateOne,
  deleteOne,
  restoreOne,
  removeOne,
  updateMenu
}



// WEBPACK FOOTER //
// ./src/api/OrganizationApi.js